/**
 * 列表筛选用下拉框，默认带「全部」选项，便于取消筛选
 */
export default {
  name: 'FilterSelect',
  inheritAttrs: false,
  props: {
    showAll: {
      type: Boolean,
      "default": true
    },
    allLabel: {
      type: String,
      "default": '全部'
    },
    allValue: {
      "default": ''
    }
  }
};